<template>
  <div class="productCenterDetails">
    <div class="background">
      <h2>产品中心</h2>
    </div>
    <div class="breadcrumb">
      <img
        src="../../assets/product_center_details/产品中心home_icon.png"
        alt=""
      />
      <span @click="tableSwitch(1)">首页</span>
      <span v-html="'&nbsp;>&nbsp;'"></span>
      <span @click="tableSwitch(2)">产品中心</span>
      <span v-html="'&nbsp;>&nbsp;'"></span>
      <span>手持盘存机</span>
    </div>
    <div class="contentBox">
      <h2>手持盘存机</h2>
      <img src="../../assets/product_center_details/标题装饰.png" alt="" />
      <div></div>
      <img src="../../assets/product_center_details/示例图_4.png" alt="" />
      <p
        class="introduce"
        v-html="
          '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;自动手持盘存机（JELON C1）采用Arm Cortex-A73架构八核高端CPU，设备运行最新的Android10.0 操作系统,采用全贴合工艺的5.5寸IPS高亮屏,内置9000mAh 超大容量一体化聚合物锂电池,顶级RFID读写性能,支持多标签读取，多标签读取速率为200Tag/s,自主知识产品的控制系统，是试剂仓储盘点的神器。<br/>①行业领先的高端八核CPU<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;行业唯一采用Arm Cortex-A73架构八核高端CPU，基于台积电领先的12nm 制程工艺，性能领先竞品3-8代，拥有高阶功能和出色的性能体验,极速运行各种应用程序，整体性能全面碾压行业竞品，与其它竞品相比，具有压倒性的优势。<br/>②采用最新的安卓系统<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;设备运行最新的Android10.0 操作系统，使其支持更多的应用功能，系统运行更加流畅，安全性更高。 <br/>③5.5寸IPS高亮屏，突破视野边界<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;设备采用全贴合工艺的5.5寸IPS高亮屏，有效的提升了屏幕的显示亮度，即使在阳光下，显示内容也清晰可见，得益于5.5寸全面屏的加持，设备单窗口下可显示更多的内容。 <br/>④持久的续航动力<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;设备内置9000mAh 超大容量一体化聚合物锂电池，CPU采用台积电领先的12nm FinFET 制程工艺，并搭载CorePilot 4.0省电技术，展现领先同级的性能与功耗表现，保障设备全天连续可操作。 <br/>⑤全协议NFC读卡功能，人性化的读卡位置设计<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;设备集成13.56MHz的NFC读卡功能，全面支持ISO14443A/B 、ISO15693, NFC-IP1，NFC-IP2等协议标准，读卡位置部署在前端扫描头窗口处，操作方便。<br/>⑥业内顶级RFID读写性能<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;以9662白卡测试为标准，室内可达40米左右读距，室外空旷环境可达20米左右读距（具体读距与标签和环境有关），支持多标签读取，多标签读取速率为200Tag/s,1800 张标签用时10S左右盘全（采用impinj H47测试，实际可受标签及环境影响），设备RFID性能比同类竞品性能提升至少30%以上，全面碾压行业竞品。<br/>⑦自主研发新一代高性能四臂螺旋天线<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;该天线具有重量轻、体积小、窄波速、高增益、低驻波、方向图对称性好，全向读取性能优，抗干扰能力强等特点。<br/>⑧卓越的散热性能<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;RFID模块固定结构部分采用优质航空铝材，大大的增加了射频模块的散热性能，确保设备在满功率下持续流畅运行.'
        "
      ></p>
    </div>
  </div>
</template>

 <script>
export default {
  data() {
    return {
      activeNavItem: 1,
    };
  },
  methods: {
    tableSwitch(v) {
      this.$bus.$emit("tableSwitch", v);
    },
  },
};
</script>

 <style lang="scss" scoped>
.productCenterDetails {
  width: 100%;
  position: relative;
  .background {
    width: 100%;
    height: 420px;
    background: url("../../assets/product_center/背景.png") 0 0/100% 100%
      no-repeat;
    position: relative;
    h2 {
      width: 100%;
      height: 60px;
      font-size: 60px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 60px;
      color: #ffffff;
      text-align: center;
      position: absolute;
      top: 168px;
      left: 0;
    }
  }
  .breadcrumb {
    width: 1200px;
    height: 62px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 120, 255, 0.41);
    opacity: 0.8;
    display: flex;
    align-items: center;
    position: absolute;
    top: 385px;
    left: 360px;
    z-index: 9;
    img {
      width: 26px;
      height: 26px;
      margin-left: 26px;
      margin-right: 20px;
    }
    span {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      &:nth-of-type(1),
      &:nth-of-type(3) {
        cursor: pointer;
      }
      &:nth-of-type(5) {
        color: #0078ff;
      }
    }
  }
  .contentBox {
    width: 1200px;
    // height: 7746px;
    margin: 0 auto;
    text-align: center;
    h2 {
      &:nth-of-type(1) {
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #000000;
        line-height: 30px;
        margin-top: 115px;
      }
    }
    img {
      &:nth-of-type(1) {
        width: 220px;
        height: 3px;
        margin-top: 19px;
        margin-bottom: 40px;
      }
      &:nth-of-type(2) {
        margin-bottom: 55px;
      }
    }
    p {
      width: 100%;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
      line-height: 36px;
      margin-bottom: 60px;
    }
    .title {
      margin-bottom: 39px;
    }
    .example {
      margin-bottom: 40px;
    }
    .introduce {
      text-align: left;
      margin-bottom: 60px;
    }
  }
  .navMenu {
    width: 120px;
    height: 900px;
    background: #f1f8ff;
    box-shadow: 0px 0px 8px 0px rgba(0, 120, 255, 0.13);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 459px;
    left: 102px;
    .navItem {
      width: 120px;
      height: 100px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: relative;
      .decorate {
        width: 78px;
        height: 1px;
        background: #dcdcdc;
        position: absolute;
        top: -0.5px;
        left: 21px;
      }
      img {
        position: relative;
        top: -15px;
        &:nth-of-type(1) {
          display: block;
        }
        &:nth-of-type(2) {
          display: none;
        }
      }
      span {
        width: 100%;
        height: 18px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        position: absolute;
        top: 65px;
        left: 0;
      }
    }
    .activeNavItem {
      background: #0078ff;
      .decorate {
        display: none;
      }
      img {
        &:nth-of-type(1) {
          display: none;
        }
        &:nth-of-type(2) {
          display: block;
        }
      }
      span {
        color: #ffffff;
      }
    }
  }
}
</style>